import { Component,
    Input,
    ComponentFactory,
    ComponentRef,
    AfterViewInit,
    ViewContainerRef,
    TemplateRef
} from '@angular/core';
const _ = require('lodash');
import { TreeNode } from '../models/tree-node.model';
import { TreeService } from '../services/tree.service';

@Component({
    selector: 'TreeNodeIcon',
    styles: [require('./tree-node.scss')],
    template: `<span *ngIf="!template" [ngClass]="clazz"></span>
        <ng-template [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ $implicit: node, node: node, index: index }">
        </ng-template>`
})

export class TreeNodeIcon implements AfterViewInit {
    @Input() index: number;
    @Input() node: TreeNode;
    @Input() clazz: String;
    @Input() template: TemplateRef<any>;

    constructor(private treeService: TreeService,
                private viewContainerRef: ViewContainerRef) {
    }

    ngAfterViewInit() {
        // TODO
    }

    ngOnChanges() {
        if (_.isEmpty(this.clazz) || _.isNull(this.clazz)) {
            this.clazz = 'tree-node-icon';
        } else {
            this.clazz = 'tree-icon ' + this.clazz;
        }
    }
}




// WEBPACK FOOTER //
// ./src/common/tree/components/tree-node-icon.component.ts